/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

import { ENVIRONMENT } from 'config';

const TIME_OUTS = {
  REDIRECT_TO_LOGIN: 5,
  SESSION_REFRESH_TIME: 60,
  P_B_TOKEN_REFRESH_TIME: 600,
  SESSION_OBSERVER_TIME: 5000,
  ACCESS_TOKEN_REFRESH_LEEWAY: 10,
  REFRESH_TOKEN_RETRY_DELAYS: [1000, 2000, 4000],
  REQUEST_TIMEOUT_MS:
    ENVIRONMENT.REQUEST_TIMEOUT_MS !== undefined && ENVIRONMENT.REQUEST_TIMEOUT_MS !== ''
      ? Number(ENVIRONMENT.REQUEST_TIMEOUT_MS)
      : 30000,
  LONG_REQUEST_TIMEOUT_MS: 120000,
  AUTH_REQUEST_TIMEOUT_MS: 10000,
};
export default TIME_OUTS;
